<template>
  <div class="h-1 overflow-hidden bg-shade-300 md:mx-4 md:rounded-lg">
    <div
      class="h-full origin-left rounded-r-lg bg-black transition-transform md:rounded-lg"
      :style="{
        transform: `scaleX(${progress})`,
      }"
    ></div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  length: {
    type: Number as PropType<number>,
    required: true,
  },
  current: {
    type: Number as PropType<number>,
    default: 0,
  },
})

const progress = computed(() => {
  return (props.current + 1) / props.length
})
</script>
